import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SurveyList from '../components/SurveyList';
import { createSurvey } from '../utils/serverComm';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleCreateSurvey = async () => {
    try {
      const newSurvey = await createSurvey();
      navigate(`/survey/${newSurvey.surveyId}`);
    } catch (error) {
      console.error('Failed to create survey:', error);
      toast.error('Failed to create new survey');
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Welcome Header */}
      <div className="text-center py-8">
        <h1 className="text-4xl font-bold text-gray-900">Welcome to ClickHeard</h1>
      </div>

      {/* Main Content Container */}
      <div className="max-w-5xl mx-auto px-6 w-full">
        {user ? (
          <SurveyList onCreateSurvey={handleCreateSurvey} />
        ) : (
          <div className="text-center">
            <p className="text-xl text-gray-600 mb-6">Please click Sign In.</p>
            <Link 
              to="/signin" 
              className="inline-block px-6 py-2 bg-black text-white rounded hover:bg-gray-800"
            >
              Sign In
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
